import { render, staticRenderFns } from "./JdsPageIntro.vue?vue&type=template&id=3607c251&scoped=true&"
import script from "./JdsPageIntro.vue?vue&type=script&lang=ts&"
export * from "./JdsPageIntro.vue?vue&type=script&lang=ts&"
import style0 from "./JdsPageIntro.vue?vue&type=style&index=0&id=3607c251&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3607c251",
  null
  
)

export default component.exports